import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  DialogContentText,
  Button
} from '@material-ui/core/';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

import ButtonClose from "../../../../../../../../../../../util/buttonClose/.mixins/buttonClose";

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default ({
    open,

    handleImprimir,
    handleClose,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      align={"center"}
    >
      <div className={classes.root}>
        <Typography>
          O AGENDAMENTO FOI CONFIRMADO COM SUCESSO!
          <ButtonClose closeMethod={handleClose}/>
        </Typography>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            O endereço e data da entrega poderão ser consultados na tela de "Protocolos de Agendamento".
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button
            variant={"outlined"}
            color={"primary"}
            startIcon={<FontAwesomeIcon icon={faPrint}/>}
            onClick={handleImprimir}
            hidden
          >
            IMPRIMIR INSTRUÇÕES DE TRANSPORTE
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
